<template>
  <uni-popup ref="msWriteReport" :mask="true" :maskClick="true" type="bottom" @change="changePopup">
    <div class="ms-write-report" @touchstart.stop @click.stop>
      <div class="popup-header">
        <div class="close">
          <uni-icons type="closeempty" color="#666" @click="close" />
        </div>
        <div class="title">撰写报告</div>
      </div>
      <div class="content-wrap">
        <div class="show-wrap">
          <div class="label"><span class="required">*</span> 参考建议：</div>
          <div class="content">
            <textarea
              v-model="formData.diagnosticAdvice"
              placeholder="请输入参考建议"
              class="remark-textarea"
              :show-confirm-bar="false"
              :maxlength="200"
            ></textarea>
          </div>
        </div>
        <div class="show-wrap">
          <div class="label"><span class="required">*</span>治疗建议：</div>
          <div class="content">
            <textarea
              v-model="formData.treatmentAdvice"
              placeholder="请输入治疗建议"
              class="remark-textarea"
              :show-confirm-bar="false"
              :maxlength="200"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="cancel" @click="close">取消</div>
        <div class="submit" @click="onSaveReport">保存</div>
      </div>
    </div>
  </uni-popup>
</template>

<script>
import { fUpdateReginfo, getVisitRecordOnlineDetail } from '@/views/funcPuzzle/utils/index.js'
import { showModal } from '@/views/funcPuzzle/utils/util.js'

export default {
  props: {
    value: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      formData: {
        id: '',
        diagnosticAdvice: '', // 诊断
        treatmentAdvice: '' // 治疗
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          open()
          getDetail(val)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取报告详情
    async getDetail(data) {
      // 如果不用接口需要更新页面的数据
      try {
        const { VisitRecordOnlineDetail } = await getVisitRecordOnlineDetail({
          visitID: data.visitID
        })
        Object.assign(this.formData, {
          id: VisitRecordOnlineDetail.id,
          diagnosticAdvice: VisitRecordOnlineDetail.diagnosticAdvice,
          treatmentAdvice: VisitRecordOnlineDetail.treatmentAdvice
        })
      } catch (e) {
        console.log(e)
      }
    },

    // 打开
    open() {
      this.$refs.msWriteReport.open()
    },
    // 关闭
    close() {
      this.$refs.msWriteReport.close()
    },
    // 打开/关闭popup
    changePopup({ show }) {
      if (!show) {
        this.$emit('input', null)
      }
    },

    // 校验表单
    validateForm() {
      if (!formData.diagnosticAdvice) {
        showModal({
          title: '温馨提示',
          content: '请输入参考建议',
          showCancel: false
        })
        return false
      }
      if (!formData.treatmentAdvice) {
        showModal({
          title: '温馨提示',
          content: '请输入治疗建议',
          showCancel: false
        })
        return false
      }
      return true
    },
    // 保存报告
    async onSaveReport() {
      if (!this.validateForm()) {
        return
      }
      try {
        const { code, codeDesc } = await fUpdateReginfo(formData.value)
        if (String(code) !== '0') {
          // showModal({
          //   title: '温馨提示',
          //   content: String(codeDesc || '保存报告失败'),
          //   showCancel: false
          // })
          return
        }
        showModal({
          title: '温馨提示',
          content: codeDesc || '保存成功',
          showCancel: false
        })
        close()
        // 保存报告后更新详情
        this.$emit('detail')
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin iosPadding($pos) {
  padding-#{$pos}: constant(safe-area-inset-#{$pos});
  padding-#{$pos}: env(safe-area-inset-#{$pos});
}

@mixin ellipsis($line: 1) {
  @if $line > 1 {
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: $line; //行数
    line-clamp: $line;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    word-break: break-all;
    overflow: hidden;
  } @else {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.ms-write-report {
  height: 17.92rem;
  border-radius: 0.853333rem 0.853333rem 0 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;

  @include iosPadding(bottom);
  .popup-header {
    flex: 0 0 auto;
    position: relative;
    padding: 0.426667rem 0.682667rem;
    display: flex;
    align-items: center;
    border-radius: 0.853333rem 0.853333rem 0 0;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 4;
      height: 0.042667rem;
      background: #ececec;
      transform: scaleY(0.5);
    }
    .title {
      flex: 1;
      font-size: 0.725333rem;
      line-height: 0.938667rem;
      font-weight: 500;
      color: #171a1d;
      text-align: center;
    }
    .close {
      // 图标太小展位大点好点击
      flex: 0 0 auto;
    }
  }

  .content-wrap {
    flex: 1;
    overflow-y: auto;

    .show-wrap {
      position: relative;
      padding-left: 0.682667rem;
      padding-right: 0.682667rem;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 4;
        height: 0.042667rem;
        background: #ececec;
        transform: scaleY(0.5);
      }

      .label {
        padding-right: 0.256rem;
        display: flex;
        flex: 0 0 auto;
        font-size: 0.64rem;
        line-height: 2.005333rem;
        font-weight: 400;
        color: #888;

        .required {
          flex: 0 0 auto;
          font-size: 0.64rem;
          line-height: 1.92rem;
          color: #f53f3f;
        }
      }

      .content {
        padding-right: 0.256rem;
        padding-bottom: 0.64rem;
        flex: 1;
        display: flex;
        justify-content: flex-end;

        .remark-textarea {
          box-sizing: border-box;
          padding: 0.32rem;
          flex: 1;
          display: block;
          width: 100%;
          height: 2.56rem;
          overflow: auto;
        }
      }
    }
  }

  .btn-wrap {
    flex: 0 0 auto;
    background: #fff;
    padding: 0.341333rem 0.682667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0rem -0.085333rem 0.170667rem 0rem rgba(0, 0, 0, 0.05);

    .cancel {
      flex: 0 0 6.912rem;
      width: 6.912rem;
      font-size: 0.682667rem;
      line-height: 1.877333rem;
      text-align: center;
      color: #366ef4;
      border: 0.042667rem solid #366ef4;
      background: #fff;
      border-radius: 0.170667rem;
    }

    .submit {
      @extend .cancel;
      background: #366ef4;
      color: #fff;
    }
  }
}
</style>
